import React from "react";
import { GatsbyImage as Img, IGatsbyImageData } from "gatsby-plugin-image";

interface GatsbyImageProps {
	aspectRatio: string;
	base64: string;
	sizes: string;
	src: string;
	srcSet: string;
	srcSetWebp: string;
	srcWebp: string;
}

interface AdaptiveImageProps {
	className: string;
	id: string;
	src: string | IGatsbyImageData;
	height?: number;
	width?: number;
}

export default function AdaptiveImage({ className, id, src, loading, height, width }: AdaptiveImageProps) {
	if (typeof src === "string") {
		return <img src={src} id={id} className={className} alt="" loading={loading} height={height} width={width} />;
	}

	if (typeof src === "object") {
		return <Img image={src} id={id} className={className} alt="" loading={loading} />;
	}

	return (
		<div id={id} className={className}>
			Image of unsupported type
		</div>
	);
}
